import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TAGLI_CONTANTI } from '../../../lib/constants';

export interface DepositCashDialogData {
  idIncasso: number;
  dataIncasso: string;
  totaleMonete: number;
  totaleBanconote: number;
  totale: number;
  tagli: { taglio: number; quantita: number; importo: number }[];
}

interface RigaTaglio {
  descrizione: string;
  taglio: number;
  quantita: number;
  importo: number;
}

@Component({
  selector: 'rev-receipts-deposit-cash-dialog-component',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './receipts-deposit-cash-dialog-component.html',
  styleUrl: './receipts-deposit-cash-dialog-component.scss',
})
export class receiptsDepositCashDialogComponent {
  readonly righe: RigaTaglio[];

  constructor(@Inject(MAT_DIALOG_DATA) readonly data: DepositCashDialogData) {
    // Una riga per ogni taglio, anche quelli a zero: la distinta cartacea le
    // ha tutte e l'agente conta scorrendo l'elenco.
    this.righe = TAGLI_CONTANTI.filter(taglio => taglio.importoTaglio > 0).map(taglio => {
      const presente = data.tagli?.find(t => t.taglio === taglio.importoTaglio);

      return {
        descrizione: taglio.descrizioneTaglio,
        taglio: taglio.importoTaglio,
        quantita: presente?.quantita ?? 0,
        importo: presente?.importo ?? 0,
      };
    });
  }

  formatAmount(value: number): string {
    return `€ ${value.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
}
